
import { useEffect } from 'react';
import { useTeamData } from './useTeamData';
import { useClubCoachData } from './useClubCoachData';
import { useTeamForm } from './useTeamForm';

export const useTeamManagement = (clubId?: string) => {
  const { teams, loading, fetchTeams, handleDelete } = useTeamData(clubId);
  const { clubCoaches, coachesLoaded } = useClubCoachData(clubId);
  const teamForm = useTeamForm(clubId, fetchTeams);

  return {
    teams,
    clubCoaches,
    loading,
    coachesLoaded,
    ...teamForm,
    handleDelete,
    fetchTeams
  };
};
